/**
 * Convert the customer name into a customer slug usable inside an url
 * demo_bess -> demo-bess
 */
export function customerSlug(name: string): string {
  return name.toLowerCase().replaceAll('_', '-');
}

export function siteLabel(siteId: string): string {
  return siteId.replaceAll('_', ' ');
}

export function siteId(siteLabel?: string): string | undefined {
  return siteLabel?.replaceAll(' ', '_');
}
